import { Nullable } from "ng/src/app/shared/model/app.model";

export class FileDetailType {
	static getType(contentType: string) {
		let type = FileDetailType.Type.UNKNOWN;
		contentType = contentType.toLocaleLowerCase();
		
		if (contentType.includes('image')) {
			type = FileDetailType.Type.IMAGE;
		}
		else if (contentType.includes('application/pdf')) {
			type = FileDetailType.Type.PDF;
		}
		else if (contentType.includes('video')) {
			type = FileDetailType.Type.VIDEO;
		}
		else if (contentType.includes('audio')) {
			type = FileDetailType.Type.AUDIO;
		}
		else if (contentType.includes('text/plain')) {
			type = FileDetailType.Type.PLAIN_TEXT;
		}
		
		return type;
	}
	
	static canPlayType(contentType: string): boolean {
		const type = this.getType(contentType);
		let mediaElement: Nullable<HTMLMediaElement> = null;
		
		switch (type) {
			case FileDetailType.Type.AUDIO: {
				mediaElement = document.createElement('audio');
				break;
			}
			case FileDetailType.Type.VIDEO: {
				if (contentType === 'video/quicktime') {
					contentType = 'video/mp4'
				}
				mediaElement = document.createElement('video');
				break;
			}
		}
		const playResult = mediaElement?.canPlayType(contentType);
		return playResult === 'probably' || playResult === 'maybe';
	}
}

export type FileDetailPreviewStyle = Partial<Record<FileDetailType.Type, Partial<CSSStyleDeclaration>>>

export module FileDetailType {
	export enum Type {
		UNKNOWN = 'UNKNOWN',
		IMAGE = 'IMAGE',
		VIDEO = 'VIDEO',
		AUDIO = 'AUDIO',
		PLAIN_TEXT = 'PLAIN_TEXT',
		PDF = 'PDF'
	}
}